module.exports = __webpack_public_path__ + "school/img/practiceNationCultureBg.a73d3e4e.jpg";